<template><div><h1 id="pivot-ereignisvergleich" tabindex="-1"><a class="header-anchor" href="#pivot-ereignisvergleich"><span>Pivot Ereignisvergleich</span></a></h1>
<p>Pivot Ereignisvergleich — Umsatz-Vergleichskurven von Ereignissen, nach Tagen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Ziel dieser Auswertung ist ein Report, womit Umsätze von Mailings/Ereignissen verglichen werden können. Basis dafür bildet ein Excel mit einer Pivot-Tabelle. Die Quelle dafür ist eine exportierte Excel-Tabelle, worin jeweils pro Tag und Ereignis eine Zeile exportiert wird. Verglichen wird jeweils 1 Ereignis mit einem anderen oder mehreren (zusammengefassten) Ereignissen.</p>
<p>Im Report enthalten sind, neben den 2 Datentabellen, 4 weitere Tabellenblätter mit Pivots/Charts:</p>
<ol>
<li>
<p>Vergleichskurve &quot;kumuliert&quot;:</p>
<p>Zeigt 2 Kurven mit dem wachsenden Umsatz, nach Tagen.</p>
</li>
<li>
<p>Vergleichskurve &quot;nach Tagen&quot;:</p>
<p>Zeigt 2 Kurven mit dem jeweiligen Umsatz pro Tag.</p>
</li>
<li>
<p>Vergleichskurve &quot;kumuliert und normalisiert&quot;:</p>
<p>Wie &quot;Vergleichskurve kumuliert&quot; aber das resp. die Vergleichsereignis(se) sind normalisiert.</p>
</li>
<li>
<p>Vergleichskurve &quot;nach Tagen und normalisiert&quot;:</p>
<p>Wie &quot;Vergleichskurve nach Tagen&quot; aber das resp. die Vergleichsereignis(se) sind normalisiert.</p>
</li>
</ol>
<p>Die &quot;Normalisierung&quot; wird verwendet, damit Mailings mit unterschiedlicher Initialanzahl verglichen werden können. Die Formel dafür ist folgende:</p>
<p>&quot;Tages-Responswert Ereignis&quot;/&quot;Anzahl Initalereignisse&quot; * 100</p>
<p>Bei den exportierten Tagen werden Wochenenden und Schweizer Feiertage nicht berücksichigt/ausgefiltert, weil da sowieso keine Zahlungen verbucht werden.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Pivot Ereignisvergleich</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Ereignis</dt>
<dd>Lookup auf die Stammtabelle der Ereignisse</dd>
<dt>vergleichen mit</dt>
<dd>Ein einzelnes Ereignis oder mehrere. Mehrere Ereignisse werden zu 1 Vergleichsereignis &quot;Diverse&quot; zusammengefasst. Im Lookup können auch Ereignisknoten ausgewählt werden.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Es wird eine Excel-Datei mit 6 Tabellenblättern erstellt (siehe oben)</p>
</div></template>


